import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router'
import Loading from 'src/components/Loading/Loading'
import { FormattedMessage } from 'react-intl'
import { setUserSecret } from 'src/utils/helper'
import { useUserActions } from 'src/hooks/api'
import './Associate.sass'

declare const window: any

const Associate = () => {
  const { id, secret } = useParams()
  const [status, setStatus] = useState('')
  const navigate = useNavigate()
  const { associate } = useUserActions()

  useEffect(() => {
    setStatus('loading')
    associate(secret, id)
      .then(({ email, secret }) => {
        setUserSecret(email, secret)
        window.fcmSubscribe && window.fcmSubscribe()
        navigate('/', { replace: true })
      })
      .catch((e) => {
        setStatus('error')
        console.log(e)
      })
  }, [secret, id])

  return (
    <div id="associate" className="page split">
      <header className="item left" />
      <section className="item right">
        <div className="wrapper">
          <img src="/images/logo.png" alt="logo" />
          {status === 'loading' ? (
            <Loading />
          ) : (
            <div className="associate-error">
              <h2>Error</h2>
              <p className="error-description">
                <FormattedMessage id="two-factor.error-associate" />
              </p>
              <button
                className="filled"
                onClick={() => navigate('/', { replace: true })}
              >
                <FormattedMessage id="two-factor.error-go-home" />
              </button>
            </div>
          )}
        </div>
      </section>
    </div>
  )
}

export default Associate
